// ค่า config อ่านจาก 2 ที่ เรียงตามลำดับความสำคัญ
//
//   1. runtime  — window.__ENV__ ที่ /env.js กำหนดไว้
//                 /env.js ถูกเขียนใหม่ทุกครั้งที่ container start โดย docker-entrypoint.sh
//                 จาก env ของ pod (Vault -> ExternalSecret -> envFrom ใน web-deployment.yaml)
//                 แก้ค่าใน Vault แล้ว rollout restart ก็เปลี่ยนได้ ไม่ต้อง rebuild image
//
//   2. build-time — process.env ที่ webpack DefinePlugin ฝังมาจาก .env ตอน build
//                   ใช้ตอน local dev (preact watch) ที่ไม่มี /env.js
//
// docker-entrypoint.sh เก็บ env ทุกตัวที่ขึ้นต้นด้วย REACT_ หรือ LARK_ ให้เอง
// เพิ่ม key ใหม่ไม่ต้องแก้ entrypoint แค่เพิ่มบรรทัดในนี้
const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};
const buildTimeEnv = process.env || {};

// runtime ที่เป็น string ว่างถือว่าไม่ได้ตั้ง จะ fallback ไปค่าที่ฝังมาตอน build
const read = (key) => {
  const value = runtimeEnv[key];
  return value === undefined || value === '' ? buildTimeEnv[key] : value;
};

export const env = {
  title: read('REACT_APP_TITLE'),
  url: read('REACT_APP_URL_HOST'),
  node: read('REACT_APP_NODE_ENV'),
  node_env: read('REACT_APP_NODE_ENV'),
  port: read('REACT_APP_PORT'),
  analytic: read('REACT_ANALYTICS_KEY'),
  version: read('REACT_APP_VERSION'),
  google: {
    client_key: read('REACT_APP_GOOGLE_CLIENT_KEY'),
  },
  url_dev: read('REACT_APP_URL_DEV'),
  // services/index.js อ่าน env.url_uat แต่ไฟล์นี้ไม่เคย map ให้
  // -> CONNECT_API เป็น undefined เวลา node_env เป็น UAT
  url_uat: read('REACT_APP_URL_UAT'),
  url_prd: read('REACT_APP_URL_PRD'),
  key_storage: read('REACT_APP_KEY_STORAGE') || '',
  key_hash: read('REACT_APP_KEY_HASH'),
};
